import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useWindowSize } from "go-core/components/useWindowSize";
import { redirectToApplication } from "go-core/utils/utils";
import { NEW_WAY_TO_ENCODING_FILTER_SIGN } from "go-list/core/components/Filter/services";
import { AddonApi } from "../../../../../../../../services/Api/Subscription/subscriptionTypes";
import { ConfigContext } from "../../../../../../../../services/Config/context";
import { selectOrganization } from "../../../../../../../../services/organizations/selectors";

interface Props {
	addon: AddonApi;
}

const AddonUsageWarning = ({ addon }: Props) => {
	const { t } = useTranslation();
	const config = useContext(ConfigContext);
	const organization = useSelector(selectOrganization);
	const isSmallBreakpoint = useWindowSize().isSmallBreakpoint;

	const getWarningMessage = () => {
		if (addon?.warning?.code === "invalid_subscription_for_usage") {
			let featureTranslation = "";
			if (addon.warning.feature === "terminal-kds-limit") {
				featureTranslation = t("modules.subscription.field.terminal_kds_limit.title");
			} else if (addon.warning.feature === "terminal-kiosk-limit") {
				featureTranslation = t("modules.subscription.field.terminal_kiosk_limit.title");
			} else if (addon.warning.feature.includes("terminal")) {
				featureTranslation = t("modules.subscription.field.terminal_limit.title");
			}

			const link = getLink();

			return (
				<p className="mb-0">
					{`${t("constraints.invalid_subscription_for_usage", {
						count: addon.warning?.usage_value,
					})} ${featureTranslation ?? ""}`}
					{featureTranslation && link && (
						<a
							className="ms-1 text-danger text-decoration-underline"
							href={link}
							target="_blank"
							rel="noopener noreferrer"
						>
							{t("modules.subscription.field.terminal_link.title")}
						</a>
					)}
				</p>
			);
		}
	};

	const getTerminalType = () => {
		switch (addon.warning?.feature) {
			case "terminal-kiosk-limit":
				return "KIOSK";
			case "terminal-kds-limit":
				return "KDS";
			case "terminal-pos-limit":
				return "POS";
			case "terminal-customer-display-limit":
				return "KDS_NUMBER";
			case "terminal-mobile-limit":
				return "POS_MOBILE";
			default:
				return "";
		}
	};

	const getLink = () => {
		if (addon.warning?.feature?.includes("terminal")) {
			const apps = config.applications();
			const goposApp = apps.find((app) => app.id.toLowerCase() === "gopos");
			let filter = "";
			const terminalType = getTerminalType();

			if (terminalType) {
				filter = btoa(unescape(encodeURIComponent(`${NEW_WAY_TO_ENCODING_FILTER_SIGN}type|e=${terminalType}`)));
			}

			return redirectToApplication(
				goposApp?.url ?? "",
				organization.company_id,
				`/settings/terminals${filter ? `?f=${filter}` : ""}`
			);
		}
	};

	return getWarningMessage() ? (
		<div className={`d-inline-block text-danger ${isSmallBreakpoint ? "mb-1" : "mb-2"}`}>{getWarningMessage()}</div>
	) : (
		<></>
	);
};

export default AddonUsageWarning;
